import React from "react"
import { graphql } from "gatsby"
import Reveal from "../utils/Reveal"

import Section from "../atoms/Section"

import Box from "../atoms/Box"
import SectionTitle from "../molecules/SectionTitle"
import ImageTextSection from "./ImageText/ImageTextSection"
import { getSectionId } from "../page/Sections"
import { cloneDeep } from "lodash"
import FlexGrid from "../atoms/FlexGrid"

const FlexColumns = ({
  section,
  sectionTitle,
  FCSectionTitle,
  flexColumns,
  flexGrid,
  columnsRatio,
  transparentBg,
  mobileStackFirst,
}) => {
  const sectionTitleObj = sectionTitle || FCSectionTitle

  return (
    <Section {...section}>
      <Reveal>
        <Box>
          {sectionTitleObj && (
            <Box pb={6}>
              <SectionTitle {...sectionTitleObj} />
            </Box>
          )}
          <FlexGrid
            columnsRatio={columnsRatio}
            display="flex"
            {...flexGrid}
            flexDirection={{
              _:
                mobileStackFirst === "rightColumn"
                  ? "column-reverse"
                  : "column",
              md: "row",
            }}
            columns={
              typeof flexGrid?.columns === "number"
                ? { _: 1, md: flexGrid.columns }
                : flexGrid?.columns
            }
          >
            {flexColumns &&
              flexColumns.map((flexColumnSection, idx) => {
                const flexColumn = cloneDeep(flexColumnSection)
                if (flexColumn.section) {
                  if (flexColumn.section.hidden) {
                    return null
                  }
                  flexColumn.section.sectionId = getSectionId(flexColumn)
                }
                return (
                  <ImageTextSection
                    key={idx}
                    {...flexColumn}
                    transparentBg={transparentBg}
                    section={{
                      ...flexColumn,
                      contentLocation: section.contentLocation,
                      verticalPadding: {
                        ...flexColumn.verticalPadding,
                        py: { _: "0px", md: "auto" },
                      },
                      style: { height: "100%" },
                    }}
                    imageFieldPrefix={`${section.sectionId}.flexColumns[${idx}]`}
                  />
                )
              })}
          </FlexGrid>
        </Box>
      </Reveal>
    </Section>
  )
}

export default FlexColumns

export const query = graphql`
  fragment FlexColumns on STRAPI__COMPONENT_SECTIONS_FLEX_COLUMNS {
    strapi_id
    section {
      ...Section
    }
    FCSectionTitle: sectionTitle {
      ...SectionTitle
    }
    flexGrid {
      ...FlexGrid
    }
    flexColumns {
      ...ImageTextSection
    }
    columnsRatio
    mobileSpacing
    transparentBg
    mobileStackFirst
  }
`
